<template>
  <!-- 待学习 -->
  <div class="toLearn">
    <van-nav-bar :title="titleText ? titleText : (ispts == 1 ? '公共课程' : '实施课程')" left-text left-arrow @click-left="onClickLeft"
      @click-right="onClickRight" :fixed="true" />
    <div class="fixedH" style="height: 1.22667rem"></div>
    <div class="fixedVanTab" v-if="canDisplay">
      <van-tabs type="card" color="#1989fa" @click="vanTabsChange">
        <van-tab v-for="(item, index) in trainsourcelist" :key="index" :title="item.trainsource">
        </van-tab>
      </van-tabs>
    </div>
    <div class="fixedH" style="height: 1rem" v-if="canDisplay"></div>
    <van-search v-model="searchVal" placeholder="请输入搜索关键词" @input="onSearch"
      :class="canDisplay ? 'fefefefef' : 'fefefefef2'" />
    <div class="fixedH" style="height: 1.35rem"></div>

    <van-list v-model="loading" :finished="finished" :finished-text="$t('toLearn.LearnTxt2')"
      @load="onLoad('firstLoading')">
      <van-collapse v-model="activeNames">
        <van-collapse-item :name="key + 'sskc'" v-show="ispts == 0" v-for="(item, key) in list2" :key="key">
          <template #title>
            <div style="display: flex; align-items: center">
              <img style="width: 24px; height: 24px" src="@/assets/img/shishikecheng.png" alt />
              <span style="
                  font-size: 15px;
                  color: #0f6ae5;
                  font-weight: bold;
                  margin-left: 6px;
                ">{{ item.coursetype }}</span>
            </div>
          </template>
          <van-cell v-for="(value, index) in item.data" :key="index" class="examList" @click="examinInfo(value, index)">
            <div class="list_no">
              {{ $t('trainRecordsDetails.TrdTxt3') }}{{ value.listno }}
            </div>
            <div class="list_va">
              <div class="left-img">
                <img :src="value.csurl ? value.csurl : require('@/assets/img/dwedewweddw.png')"
                  :style="value.csurl ? 'object-fit: contain;' : ''" alt />
              </div>
              <div class="info">
                <div class="infoExamIcon" v-if="value.coursecredit">
                  <!-- <img src="@/assets/img/trained.png" alt /> -->
                 <span> {{value.coursecredit}}{{ $t("toLearn.LearnTxt3") }}</span>
                </div>
                <!-- <p class="examName">招聘类-文秘招聘考试</p> -->
                <div class="toptop">
                  <span class="courseName">{{ value.coursename }}</span>
                </div>
                <span class="lecturerName">{{ $t("toLearn.LearnTxt4") }}{{ value.teacher_empname }}</span>
                <div class="footer">
                  <span class="date">{{ value.studybt }} - {{ value.studyet }}</span>
                </div>
                <div class="footer">
                  <span class="date">
                    <!-- {{ $t("toLearn.LearnTxt5") }}{{ value.coursehour
                    }}{{ $t("toLearn.LearnTxt6") }} -->
                  </span>
                  <div class="right">
                    <span :class="{testres:true,yellow:value.testres=='未考试',red:value.testres=='不及格'}"  v-if="value.testres">{{value.testres}}</span> 
                    <span class="score" v-if="value.isfinish">学习完成</span>
                    <!-- <span class="score" v-if="value.coursecredit">{{ value.coursecredit }}{{ $t("toLearn.LearnTxt3") }}</span> -->
                  </div>
                </div>
              </div>
            </div>
          </van-cell>
        </van-collapse-item>

        <van-collapse-item :name="key + 'ggkt'" style="margin-top: 15px;" v-show="ispts == 1" v-for="(item, key) in list1"
          :key="key">
          <template #title>
            <div style="display: flex; align-items: center">
              <img style="width: 24px; height: 24px" src="@/assets/img/gonggongkecheng.png" alt />
              <span style="
                  font-size: 15px;
                  color: #e87110;
                  font-weight: bold;
                  margin-left: 6px;
                ">{{ item.coursetype }}</span>
            </div>
          </template>
          <van-cell v-for="(value, index) in item.data" :key="index" class="examList" @click="examinInfo(value, index)">
            <div class="list_no">
              {{ $t('trainRecordsDetails.TrdTxt3') }}{{ value.listno }}
            </div>
            <div class="list_va">
              <div class="left-img">
                <img :src="value.csurl ? value.csurl : require('@/assets/img/dweddwedwddew.png')"
                  :style="value.csurl ? 'object-fit: contain;' : ''" alt />
              </div>
              <div class="info">
                <div class="infoExamIcon" v-if="value.isfinish">
                  <img src="@/assets/img/trained.png" alt />
                </div>
                <!-- <p class="examName">招聘类-文秘招聘考试</p> -->
                <div class="toptop">
                  <span class="courseName">{{ value.coursename }}</span>
                </div>
                <span class="lecturerName">{{ $t("toLearn.LearnTxt4") }}{{ value.teacher_empname }}</span>
                <div class="footer">
                  <span class="date">{{ value.studybt }} - {{ value.studyet }}</span>
                </div>
                <div class="footer">
                  <span class="date">
                    {{ $t("toLearn.LearnTxt5") }}{{ value.coursehour
                    }}{{ $t("toLearn.LearnTxt6") }}
                  </span>
                  <div class="right">
                    <span class="score" v-if="value.coursecredit">{{ value.coursecredit }}{{ $t("toLearn.LearnTxt3") }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-cell>
        </van-collapse-item>
      </van-collapse>
    </van-list>
  </div>
</template>

<script>
const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {};
import { getStudyCourseList } from "@api/wxpx.js";
export default {
  data () {
    return {
      userInfo,
      isLoading: false,
      list: [],
      list1: [],
      list2: [],
      loading: false,
      finished: false,
      activeNames: [],
      ispts: this.$route.query.ispts,
      titleText: this.$route.query.text || '',
      searchVal: "",
      trainsourcelist: [],
      sxType: ""
    };
  },
  computed: {
    canDisplay () {
      return this.trainsourcelist.length > 0 && !(this.trainsourcelist.length == 1 && this.trainsourcelist[0].trainsource == '所有')
    }
  },
  methods: {
    // 搜索
    onSearch (val) {
      if (val)
      {
        let arr1 = [];
        let arr2 = [];
        this.list = this.list.filter(item => {
          return item.coursename.indexOf(val) != -1
        })
        const data = this.list;
        data.forEach((item, key) => {
          if (item.ispts)
          {
            arr1.push(item);
          } else
          {
            arr2.push(item);
          }
        });
        this.list1 = this.getNewData(arr1, 'coursetype')
        this.list2 = this.getNewData(arr2, 'coursetype');
        console.log(this.list)
      } else
      {
        this.onLoad()
      }
    },
    examinInfo (item, key) {
      window.sessionStorage.setItem("v8_study_data", JSON.stringify(item));
      window.localStorage.setItem("learningCoursesDataKey" + item.autoid, 0);
      window.localStorage.setItem("learningCoursesDataIndex" + item.autoid, 0);
      // 跳转网址
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isAndroid)
      {
        this.$router.push({
          path: "/learningCoursesAndroid",
          query: {
            mautoid: item.autoid,
          },
        });

      } else if (isiOS)
      {
        this.$router.push({
          path: "/learningCourses",
          query: {
            mautoid: item.autoid,
          },
        });
      }else{
         this.$router.push({
          path: "/learningCourses",
          query: {
            mautoid: item.autoid,
          },
        });
      }

    },
    vanTabsChange (name, title) {
      this.sxType = title;
      this.onLoad()
      // console.log(name,title,this.list,this.list1,this.list2,'name,titlename,title')
    },
    onClickLeft () {
      if (window.CloundEntid == "115")
      {
        window.location.href = "http://hyclound.cn/hgvis_115_h5/pc2022_5.html";
      } else
      {
        this.$router.push("/home");
      }
    },
    onClickRight () { },
    groupData (arr, fun) {
      const groups = {}
      arr.forEach((el) => {
        const group = fun(el)
        groups[group] = groups[group] || []
        groups[group].push(el)
      })
      return Object.keys(groups).map((group) => {
        // 更改data的数据结构  可以改变新数据的结构 data即为newData的数组中每个数据的结构
        let data = {
          coursetype: group,
          data: groups[group]
        }
        return data
      })
    },
    getNewData (oldData, prop) {
      const newData = this.groupData(oldData, (item) => {
        return item[prop]
      })
      return newData
    },
    onLoad (jzType) {
      console.log(jzType, 'jzTypejzType')
      getStudyCourseList({
        empid: this.userInfo.empid,
        ispts: this.ispts == 0 ? false : true,
        trainsource: this.sxType
      }).then((res) => {
        console.log(res.data);
        if (res.iserror == 0)
        {
          let arr1 = [];
          let arr2 = [];
          const data = res.data;
          data.forEach((item, key) => {
            if (item.ispts)
            {
              arr1.push(item);
            } else
            {
              arr2.push(item);
            }
          });
          this.activeNames = []
          this.list = res.data;
          this.list1 = this.getNewData(arr1, 'coursetype')
          this.list2 = this.getNewData(arr2, 'coursetype');
          this.list1.forEach((item,index)=>{
            if(item.data && item.data.length > 0){
              if(!item.data[0].app_open_fold){
                this.activeNames.push(index+'ggkt')
              }
            }
          })
          this.list2.forEach((item,index)=>{
            if(item.data && item.data.length > 0){
              if(!item.data[0].app_open_fold){
                this.activeNames.push(index+'sskc')
              }
            }
          })
          this.loading = false;
          this.finished = true;
          this.trainsourcelist = res.trainsourcelist

        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.fefefefef {
  position: fixed;
  left: 0;
  top: 2.22667rem;
  z-index: 999;
  width: 100%;
  padding: 0.1rem 0.32rem 0.2rem !important;
}

.fefefefef2 {
  position: fixed;
  left: 0;
  top: 1.22667rem;
  z-index: 999;
  width: 100%;
  padding: 0.1rem 0.32rem 0.2rem !important;
}

.fixedVanTab {
  position: fixed;
  left: 0;
  top: 1.22667rem;
  z-index: 999;
  width: 100%;
  height: 1rem;
  background: #fff;
  display: flex;
  align-items: center;

  /deep/.van-tabs--card {
    width: 100% !important;
  }

  /deep/.van-tabs__nav--card {
    margin: 0 0.32rem !important;
  }
}

.toLearn {
  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }

    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }

    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }

  .left-img {
    position: relative;
    width: 342px;
    height: 190px;
    overflow: visible;
    background: #ecf2ff;
    opacity: 1;

    text-align: center;
    margin-right: 18px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      display: block;
      max-height: 100% !important;
    }
  }

  .examList {
    padding: 0 !important;
    margin-bottom: 30px !important;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);

    .van-cell__value {
      .list_no {
        padding: 0 20px;
        margin-bottom: 20px;
        font-size: 24px;
        color: #666666;
        line-height: 64px;
        word-break: break-all;
        background: linear-gradient(90deg,
            rgba(25, 137, 250, 0) 0%,
            rgba(25, 137, 250, 0.5) 0%,
            rgba(25, 137, 250, 0) 100%);
      }

      .list_va {
        display: flex;
        align-items: center;
        padding: 0 10px 10px 10px;
      }

      .info {
        flex: 1;
        position: relative;

        .infoExamIcon {
          position: absolute;
          right: 0;
          top: 0;
          z-index: 0;
          width: 90px;
          text-align: center;
          img {
            width: 90px;
          }
          span{
            background: #f0a12b;
            color: #fff;
            padding: 0 10px;
          }
        }

        .lecturerName {
          color: #999999;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
        }

        .toptop {
          display: flex;
          justify-content: space-between;
          align-items: baseline;

          .courseName {
            width: 78%;
            line-height: 1.1;
            margin: 0;
            font-size: 30px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
          }

          .right {
            .score {
              font-size: 30px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 27px;
              color: #2b8df0;
            }

            .duration {
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 27px;
              color: #333333;
            }
          }
        }

        .footer {
          width: 100%;
          display: flex;
          justify-content: space-between;

          .date {
            color: #999999;
            font-size: 20px;
          }

          .right {
            font-size: 20px;
            .testres{
               background: #36be14;
            color: #fff;
            padding: 0 10px;
            margin-right: 2px;
            }
            .testres.yellow{
              background: #bead14;
            }
            .testres.red{
              background: #be1414;
            }
            .score {              
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 27px;
              background: #2b8df0;
              color: #fff;
              padding: 0 10px;
            }

            .duration {
              font-size: 24px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              line-height: 27px;
              color: #333333;
            }
          }
        }
      }
    }
  }
}
</style>
